import { render, staticRenderFns } from "./AddOwner.vue?vue&type=template&id=3fafc018&"
import script from "./AddOwner.vue?vue&type=script&lang=js&"
export * from "./AddOwner.vue?vue&type=script&lang=js&"
import style0 from "./AddOwner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports